import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ContactForm from "../ContactForm";
import { FaWhatsapp, FaMailBulk, FaClock, FaMapMarker } from "react-icons/fa";

const Contact = ({ className = "" }) => {
   const { t } = useTranslation();

   return (
      <Container
         fluid
         className={`home-about-section ${className}`}
         id="contact"
      >
         <div
            className="contact-header"
            data-aos="fade-in"
            data-aos-duration="2000"
         >
            <h2 className="contact-title">
               {t("contact_title_1")} <span>{t("contact_title_2")}</span>
            </h2>
            <p className="contact-subtitle">{t("contact_message_part1")}</p>
            <p className="contact-subtitle">{t("contact_message_part2")}</p>
            <p className="contact-subtitle">
               <strong>{t("send_message")}</strong>
            </p>
         </div>
         <Container className="home-social-container">
            <Container id="contact-container">
               <ContactForm />
            </Container>
            <div className="contact-info">
               <div className="info-item">
                  <div className="info-icon">
                     <FaWhatsapp />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>{t("contact-info.whatsapp")}</h3>
                     <p>{t("contact-info.whatsapp_desc")}</p>
                     <a
                        href="https://wa.me/615159344"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="WhatsApp"
                     >
                        {t("contact-info.whatapp_link")}
                     </a>
                  </div>
               </div>

               <div className="info-item">
                  <div className="info-icon">
                     <FaMailBulk />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>{t("contact-info.mail")}</h3>
                     <p>{t("contact-info.mail_desc")}</p>
                     <a
                        href="mailto:falcon@joancompany.es"
                        title="Enviar correo"
                     >
                        {t("contact-info.mail_link")}
                     </a>
                  </div>
               </div>

               <div className="info-item">
                  <div className="info-icon">
                     <FaClock />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>{t("contact-info.disponibility")}</h3>
                     <p>{t("contact-info.disponibility_desc")}</p>
                  </div>
               </div>

               <div className="info-item">
                  <div className="info-icon">
                     <FaMapMarker />
                  </div>
                  <div className="contact-info-item-container">
                     <h3>{t("contact-info.ubication")}</h3>
                     <p>{t("contact-info.ubication_desc")}</p>
                  </div>
               </div>
            </div>
         </Container>
      </Container>
   );
};

export default Contact;
